import { RESTRICTED_COUNTRY_TO_CODE } from "common/constants";
import useGeoLocation from "react-ipgeolocation";

export let IS_RESTRICTED_COUNTRY = false;

export const useRestrictedCountries = () => {
  const location = useGeoLocation();
  const country = location.country;
  const restrictedCountriesCodes = Object.values(RESTRICTED_COUNTRY_TO_CODE);
  IS_RESTRICTED_COUNTRY = restrictedCountriesCodes.includes(country);
};
